import { render, staticRenderFns } from "./LastStatus.vue?vue&type=template&id=20e0558c&scoped=true&"
import script from "./LastStatus.vue?vue&type=script&lang=js&"
export * from "./LastStatus.vue?vue&type=script&lang=js&"
import style0 from "./LastStatus.vue?vue&type=style&index=0&id=20e0558c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e0558c",
  null
  
)

export default component.exports